import React from 'react';
import { Outlet } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import TechnicianNavbar from './TechnicianNavbar';

const TechnicianLayout = () => (
  <ProtectedRoute allowedRoles={['technician', 'delivery', 'admin']}>
    <div className="min-h-screen bg-slate-50">
      <TechnicianNavbar />
      <main className="mx-auto max-w-6xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  </ProtectedRoute>
);

export default TechnicianLayout;
